import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import './Hero.css';

const Hero = () => {
  const [videoLoaded, setVideoLoaded] = React.useState(false);
  const heroRef = useRef(null); 
  const videoRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    // Check if video is already ready
    if (videoRef.current) {
      videoRef.current.muted = true;
      if (videoRef.current.readyState >= 3) {
        setVideoLoaded(true);
      }
      
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
             console.log("Hero Auto-play prevented:", error);
        });
      }
    }

    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    tl.fromTo(titleRef.current, 
      { opacity: 0 },
      { opacity: 1, duration: 1.2, delay: 0.2 }
    )
    .fromTo(textRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.8 },
      "-=0.8"
    )
    .fromTo(cardRef.current,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 1 },
      "-=0.6"
    );

  }, []);

  return (
    <section className="hero-section" ref={heroRef}>
      <video 
        ref={videoRef}
        className="hero-video"
        src="/aurora_loop.mp4"
        style={{ opacity: videoLoaded ? 1 : 0, transition: 'opacity 1.5s ease-in-out' }}
        onCanPlay={() => setVideoLoaded(true)}
        onLoadedData={() => setVideoLoaded(true)}
        onPlaying={() => setVideoLoaded(true)}
        preload="metadata"
        poster="/poster.webp"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="hero-overlay"></div>
      
      <div className="hero-layout">
        <div className="hero-top-left">
          <h1 className="hero-main-title" ref={titleRef}>
            Creating digital <br />
            experiences that <br />
            matter.
          </h1>
        </div>

        <div className="hero-bottom-left">
          <p className="hero-subtext" ref={textRef}>
            Partner <strong>Website Developer Tulungagung & Jawa Timur</strong> yang siap membantu bisnis Anda tumbuh dengan desain modern, cepat, dan responsif.
          </p>
        </div>

        <div className="hero-bottom-right" ref={cardRef}>
          <div className="hero-location-card">
             <div className="loc-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5a2.5 2.5 0 0 1 0 5z"/></svg>
             </div>
             <div className="loc-divider"></div>
             <div className="loc-text">
               <span className="loc-title">Based in Tulungagung</span>
               <span className="loc-subtitle">East Java, Indonesia</span>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
